import angular from 'angular';

export default angular
  .module('app.filters.result', [])
  .filter('result', resultFilter);

/**
 * Similar to underscore/lodash's `_.result`, taking an argument of any type and returning it again,
 * only first evaluating it if its a function.
 * Useful when dealing with properties that can interchangeably be either a function or string.
 */
function resultFilter() {
  return object => (angular.isFunction(object) ? object.call(this) : object);
}
